(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-update-scripts', {
                parent: 'update_management',
                url: '/tab-update-scripts?search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts.html',
                        controller: 'TabUpdateScriptsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            objectType: $stateParams.objectType,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-update-scripts-detail', {
                parent: 'tab-update-scripts',
                url: '/tab-update-scripts/{id}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-detail.html',
                        controller: 'TabUpdateScriptsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabUpdateScripts', function ($stateParams, TabUpdateScripts) {
                        return TabUpdateScripts.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-update-scripts-new', {
                parent: 'tab-update-scripts',
                url: '/new',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-dialog.html',
                        controller: 'TabUpdateScriptsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    transaltePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            scriptName: null,
                            scriptDescription: null,
                            scriptContent: false,
                            id: null
                        };
                    }
                }
            })
            .state('tab-update-scripts-edit', {
                parent: 'tab-update-scripts',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabUpdateScripts.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-dialog.html',
                        controller: 'TabUpdateScriptsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabUpdateScripts');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabUpdateScripts', function ($stateParams, TabUpdateScripts) {
                        return TabUpdateScripts.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-update-scripts.delete', {
                parent: 'tab-update-scripts',
                url: '{id}/delete',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-update-scripts/tab-update-scripts-delete-dialog.html',
                        controller: 'TabUpdateScriptsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabUpdateScripts', function (TabUpdateScripts) {
                                return TabUpdateScripts.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-update-scripts', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
